// extracted by mini-css-extract-plugin
export default {"card":"CardsCarousel_card__azyU9","indicator":"CardsCarousel_indicator__03zQd"};